<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
         <Table :columns="columnsExpand" :data="row.items" stripe ref="table" ></Table>
    </div>
</template>
<script>
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
import AppConsts from '../../lib/appconst';
    export default {
        props: {
            row: Object
        },
         data() {
            var columns =  [
                    {
                        title: ' ',
                        key: 'qty',
                         render: (h, params) => {
                             if(params.row.qty<0)
                                return h("span", Util.L(AppConsts.poLineExceptionOperator.decrease));
                            return h("span", Util.L(AppConsts.poLineExceptionOperator.increase));

                        }
                    },
                    {
                        title: Util.L('CreationTime'),
                        key: 'creationTime',
                         render: (h, params) => {
                            return h("span", Util.toViewDateString(params.row.creationTime));
                        }
                    },
                    {
                        title: Util.L('Qty'),
                        key: 'qty',
                        align: "right",
                         render: (h, params) => {
                            return h("span", Util.toViewNumberString(Math.abs(params.row.qty)));
                        }
                    },
                    {
                        title: Util.L('Note'),
                        key: 'note'
                    }
                ]

            return {
                columnsExpand : columns,
            }
        },
    };
</script>
